import { useEffect, useState } from "react";
import styles from "./Ministers.module.scss";
import tabStyles from "../../Tab.module.scss";

interface MinisterData {
  name: string;
  bio: string;
  photo: string;
}

const MINISTER_DATA: Record<string, MinisterData> = {
  "Rev. Billy Kristanto": {
    name: "Rev. Billy Kristanto",
    bio: 'Rev. Prof. Dr. Dr. Billy Kristanto born in Surabaya. Rev. Billy Kristanto has served in church music ministry since Sunday school. After graduating from high school, he continued to study music majoring in harpsichord in UdK Berlin. In 1996, he continued with post-graduate studies in the Royal Conservatory Den Haag with Ton Koopman in harpsichord and with Stanley Hoogland in fortepiano.\n\nHe graduated in 2002 from STTRII with a Master of Christian Studies degree. In 2005 he was ordained as a pastor in the synod of IREC and is currently shepherding the IRECs in Europe. In 2009 and 2011 he finished his doctorate studies with the degree of Dr. phil. in musicology and Dr. theol. in systematic theology from the Ruprecht Karl University of Heidelberg. He teaches systematic theology at the International Reformed Evangelical Seminary Jakarta and a member of the Theological Commission of World Reformed Fellowship. His research spans soteriology, anthropology, spirituality, John Calvin’s theology, and J.S. Bach. He is also running a Youtube channel called "Sola Dei Gloria".',
    photo: "#EBEBEB url(profile-billy.png) center /cover no-repeat",
  },
  "Rev. Jack Kawira": {
    name: "Rev. Jack Kawira",
    bio: "A prominent figure in the Reformed Evangelical Church of Indonesia (GRII), serving numerous congregations in Indonesia and internationally. He is a highly regarded speaker, delivering sermons and seminars on diverse theological topics.\n\nBeyond his pastoral duties, Rev. Kawira is deeply involved in theological education at the International Reformed Evangelical Seminary (STTRII). He contributes to theological discourse, with scholarly work on practical Christian spirituality themes. His dedicated service significantly shapes the Reformed Evangelical tradition.",
    photo: "#EBEBEB url(profile-jack.png) center /cover no-repeat",
  },
  "Vic. Leonardo Chandra": {
    name: "Vic. Leonardo Chandra",
    bio: "A dedicated servant in the Reformed Evangelical Church of Indonesia (GRII), with significant involvement in youth ministry and pastoral care. He began serving in youth ministry in 2003, pursuing theological studies at STTRII Jakarta in 2012, and earning his Master of Theology in 2015. He then served as an assistant pastor at various GRII congregations until 2021.\n\nCurrently, Vic. Chandra is pursuing doctoral studies in the Netherlands and actively leads seminars and fellowships on diverse theological topics. His ongoing education and engagement underscore his commitment to spiritual and intellectual growth within the Reformed Evangelical tradition.",
    photo: "#EBEBEB url(profile-leonardo.png) center /cover no-repeat",
  },
};

const Ministers = () => {
  const [activeTab, setActiveTab] = useState<string>(
    Object.keys(MINISTER_DATA)[0],
  );
  const [isAnimating, setIsAnimating] = useState<boolean>(false);

  const minister = MINISTER_DATA[activeTab];

  useEffect(() => {
    // Animate content when tab changes
    setIsAnimating(true);
    const timeout = setTimeout(() => {
      setIsAnimating(false);
    }, 750);

    return () => clearTimeout(timeout);
  }, [activeTab]);

  return (
    <section id="ministers-profile" className={styles["ministers-profile"]}>
      <div className={styles.title}>
        <h2>Profiles of</h2>
        <h3>the pastors and vicaries</h3>
      </div>
      <div className={tabStyles["tab-group"]}>
        {Object.keys(MINISTER_DATA).map((name) => (
          <div
            key={name}
            className={`${tabStyles.tab} ${
              activeTab === name ? tabStyles.active : ""
            }`}
            onClick={() => setActiveTab(name)}
          >
            {name}
          </div>
        ))}
      </div>

      <div
        className={styles.wrapper}
        style={{
          opacity: isAnimating ? 0 : 1,
          marginTop: isAnimating ? "20px" : "0",
          transition: isAnimating
            ? "none"
            : "opacity 0.75s ease, margin-top 0.75s ease",
        }}
      >
        <div className={styles.profile}>
          <div
            className={styles.img}
            id="minister-photo"
            style={{
              background: minister.photo,
            }}
          />
        </div>
        <div className={styles.desc}>
          <h3 id="minister-name">{minister.name}</h3>
          <div id="minister-bio">
            {minister.bio.split("\n\n").map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ministers;
